import { render, staticRenderFns } from "./MobilityRentalHistory.vue?vue&type=template&id=2d820e43&scoped=true&"
import script from "./MobilityRentalHistory.vue?vue&type=script&lang=js&"
export * from "./MobilityRentalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d820e43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
